import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import TitlePrint from 'App/Shell/TitlePrint'

import Items from './Items'
import { Checkbox, Button } from 'loyal-react'
import LoggedSidebar from 'App/Shell/LoggedSidebar'
import MediaQuery from 'react-responsive'

import '@loyal_template/wishlist.css'

class WishlistPage extends Component {
  constructor (props) {
    super(props)
    this.props.loadWishList()
    this.state = {
      selectedItems: [],
      teste: true
    }
    this.selectWishlist = this.selectWishlist.bind(this)
  }

  selectWishlist (product, checked) {
    this.props.selectWishlist(product.skuId, checked)
  }

  selectAllWishlist (checked) {
    this.props.selectAllWishlist(checked)
  }

  getListToCart () {
    var list = []

    for (var i in this.props.wishlist.groupedWishlistBySkuId) {
      if (this.props.wishlist.groupedWishlistBySkuId[i].selected) {
        list.push({
          sku: this.props.wishlist.groupedWishlistBySkuId[i].skuId,
          vendorId: this.props.wishlist.groupedWishlistBySkuId[i].vendorId,
          email: this.props.email
        })
      }
    }
    return list
  }

  render () {
    if (this.props.redirectUserCart === true) {
      this.props.addCartDone()
      this.props.redirectCart()
    }
    return (
      <Fragment>
        <TitlePrint page={'Lista de desejos'} />
        <div className='container-wishlist container-fluid px-0 px-md-1 pt-0 bg-ui-4'>
          <div className='container pl-2 pr-2 pt-0 pb-2 pb-md-2 pt-md-5'>
            <div className='row pt-0 pt-md-0'>
              <LoggedSidebar selected={this.props.location.pathname} />
              <div className='user-content col-12 col-lg-8 border-color-ui-3 bg-white border radius'>
                <div className='checkout-step row px-1 py-2 border-bottom border-color-ui-3'>
                  <div className='col mr-auto'>
                    <h2 className='txt-title txt-font-body txt-initial color-title mr-auto'>
                      Favoritos{' '}
                      {this.props.wishlist.length > 0
                        ? '(' + Object.keys(this.props.wishlist.groupedWishlistBySkuId).length + ')'
                        : ''}
                    </h2>
                  </div>
                  <div
                    className={`col-auto mr-2 ${
                      !this.props.wishlist || this.props.wishlist.length === 0
                        ? 'd-none'
                        : 'd-none d-md-inline-block'
                    }`}
                  >
                    <Button
                      className='btn btn-sm btn-featured'
                      text={this.props.onlyCash ? 'Comprar agora' : 'Resgatar agora'}
                      onClick={() =>
                        this.props.addListToCart(this.getListToCart())
                      }
                      loading={this.props.wishlist.loadingAddListCart}
                      disabled={
                        !this.props.wishlist.leastOneSelected ||
                      this.props.wishlist.loadingAddListCart
                      }
                    />
                  </div>
                  <MediaQuery maxDeviceWidth={420}>
                    <div
                      className={`float-button bg-white px-2 py-2 row mx-0 ${
                        !this.props.wishlist || this.props.wishlist.length === 0
                          ? 'd-none'
                          : 'd-md-inline-block'
                      }`}
                    >
                      <div className='col-12 px-0'>
                        <Button
                          className='btn btn-sm btn-featured'
                          text={this.props.onlyCash ? 'Comprar agora' : 'Resgatar agora'}
                          onClick={() =>
                            this.props.addListToCart(this.getListToCart())
                          }
                          loading={this.props.wishlist.loadingAddListCart}
                          disabled={
                            !this.props.wishlist.leastOneSelected ||
                          this.props.wishlist.loadingAddListCart
                          }
                        />
                      </div>
                    </div>
                  </MediaQuery>
                  <div
                    className={`pos-relative col-auto txt-center ${
                      !this.props.wishlist || this.props.wishlist.length === 0
                        ? 'd-none'
                        : 'd-md-inline-block'
                    }`}
                  >
                    <div className='row align-items-center h-100'>
                      <Checkbox
                        id='checkbox_all'
                        className='col-12 pos-relative'
                        labelClass='l-0'
                        defaultChecked={this.props.wishlist.allSelected}
                        onChange={e => this.selectAllWishlist(e.target.checked)}
                      />
                    </div>
                  </div>
                </div>
                <Items
                  productsWishList={this.props.wishlist.groupedWishlistBySkuId}
                  selectItem={this.selectWishlist}
                  selectedItems={this.state.selectedItems}
                  loading={this.props.wishlist.loading}
                />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

WishlistPage.propTypes = {
  location: PropTypes.string,
  wishlist: PropTypes.array,
  email: PropTypes.string,
  loadWishList: PropTypes.func,
  addListToCart: PropTypes.func,
  selectWishlist: PropTypes.func,
  selectAllWishlist: PropTypes.func,
  redirectCart: PropTypes.func,
  addCartDone: PropTypes.func,
  allSelected: PropTypes.bool,
  leastOneSelected: PropTypes.bool,
  onlyCash: PropTypes.bool,
  redirectUserCart: PropTypes.bool
}

const mapStateToProps = ({ onlyCash }) => ({
  onlyCash
})
export default connect(
  mapStateToProps,
  null
)(WishlistPage)



// WEBPACK FOOTER //
// ./src/Participant/Wishlist/WishlistPage/WishlistPage.js